import React from "react";

export default () => (
  <svg
    width="18"
    height="11"
    viewBox="0 0 18 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.848 2.78155e-07L8.62174 7.21052L1.39546 0L0 1.39546L8.62174 10.0172L17.2434 1.39546L15.848 2.78155e-07Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="17.5" height="10.5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
